import { AdsImu2 } from "@elements/Advertisement/variant/AdsImu";
import Heading from "@elements/Typography/Heading";
import { SideBlockArticleResponse } from "@src/api/endpoint-handlers/getSideBlockArticles";
import useSwrApi from "@src/app/hooks/useSwrApi";
import { type ProcessedArticleData } from "@transformer/useOsResponse";
import { twMerge } from "tailwind-merge";

import ArticleCard from "../Card/ArticleCard";
import Divider from "../Elements/Divider/Divider";
import { MostReadArticle } from "../Elements/Typography/Link";
import { isArrayWithElements } from "../helper/utils";

export type SideBlockProps = {
  className?: string;
  sectionName?: string;
};

export default function SideBlock({ className, sectionName }: SideBlockProps) {
  const { data } = useSwrApi<SideBlockArticleResponse>("side-block-articles");
  const { EditorialList, SocialList } = data || {};
  const { data: mostReadData } = useSwrApi<ProcessedArticleData[]>("most-read");

  const SectionArticleConfig = {
    elements: { hasParagraph: false, hasDate: true },
    overrideStyle: {
      cardWrapper: "flex-row flex-row-reverse",
      titleStyle:
        "font-semibold font-primary text-2sm text-gray-100 hover:text-gray-100",
      imageWrapperStyle: "max-w-[90px] lg:w-[90px] lg:h-[90px] lg:max-h-[90px]",
      contentWrapper: "gap-xs",
      titleWrapper: "gap-0",
      imageStyle: "h-[90px] lg:h-auto",
    },
  };

  return (
    <div className={twMerge("lg:w-4/12 pl-xs pr-xxs min-h-[800px]")}>
      <div data-testid="side-block" className={twMerge("w-full", className)}>
        <AdsImu2 sectionName={sectionName} rootClassName="py-md" />
        <div className="w-full">
          {isArrayWithElements(SocialList) ? (
            <>
              <Heading
                Element="h2"
                className="text-red-100 text-md font-bold hover:underline mt-5"
              >
                <a href="/community"> சமூகம்</a>
              </Heading>
              {SocialList.map((section) => (
                <ArticleCard
                  key={section.id}
                  displayWidth={90}
                  displayHeight={90}
                  {...SectionArticleConfig}
                  {...section}
                />
              ))}
            </>
          ) : null}
        </div>
        <div className="w-full min-h-[400px]">
          {isArrayWithElements(mostReadData) ? (
            <>
              <Heading
                Element="h2"
                className="text-red-100 text-md font-bold mt-5 mb-2"
              >
                அதிகம் படித்தவை
              </Heading>
              <div className="w-full bg-red-400 py-2">
                {mostReadData.map((article, index) => (
                  <MostReadArticle
                    key={article.id}
                    counter={++index}
                    {...article}
                  />
                ))}
              </div>
              <Divider className="mt-5" />
            </>
          ) : null}
        </div>
        <div className="w-full">
          {isArrayWithElements(EditorialList) ? (
            <>
              <Heading
                Element="h2"
                className="text-red-100 text-md font-bold hover:underline mt-5"
              >
                <a href="/editorial">தலையங்கம்</a>
              </Heading>
              {EditorialList.map((section) => (
                <ArticleCard
                  key={section.id}
                  displayWidth={90}
                  displayHeight={90}
                  {...SectionArticleConfig}
                  {...section}
                />
              ))}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
